import * as types from './actionTypes';

export const submitMerchantRegistration = (payload) => ({
  type: types.SUBMIT_MERCHANT_REGISTRATION,
  payload,
});

export const submitMerchantRegistrationSuccess = (payload) => ({
  type: types.SUBMIT_MERCHANT_REGISTRATION_SUCCESS,
  payload,
});

export const submitMerchantRegistrationFailure = (payload) => ({
  type: types.SUBMIT_MERCHANT_REGISTRATION_FAILURE,
  payload,
});

export const clearMerchantRegistrationError = () => ({
  type: types.CLEAR_MERCHANT_REGISTRATION_ERROR,
});

export const setSourcePackageId = (sourcePackageId) => ({
  type: types.SET_SOURCE_PACKAGE_ID,
  payload: sourcePackageId,
});

export const clearSourcePackageId = () => ({
  type: types.CLEAR_SOURCE_PACKAGE_ID,
});

export const submitAdministrativeBillingDetails = (payload) => ({
  type: types.SUBMIT_ADMINISTRATIVE_BILLING_DETAILS,
  payload,
});

export const submitAdministrativeBillingDetailsSuccess = (payload) => ({
  type: types.SUBMIT_ADMINISTRATIVE_BILLING_DETAILS_SUCCESS,
  payload,
});

export const submitAdministrativeBillingDetailsFailure = (payload) => ({
  type: types.SUBMIT_ADMINISTRATIVE_BILLING_DETAILS_FAILURE,
  payload,
});

export const clearAdministrativeBillingDetailsSuccess = () => ({
  type: types.CLEAR_ADMINISTRATIVE_BILLING_DETAILS_SUCCESS,
});

export const getAdministrativeBillingDetails = () => ({
  type: types.GET_ADMINISTRATIVE_BILLING_DETAILS,
});

export const getAdministrativeBillingDetailsSuccess = (payload) => ({
  type: types.GET_ADMINISTRATIVE_BILLING_DETAILS_SUCCESS,
  payload,
});

export const getAdministrativeBillingDetailsFailure = (payload) => ({
  type: types.GET_ADMINISTRATIVE_BILLING_DETAILS_FAILURE,
  payload,
});

export const sendContractOtp = () => ({
  type: types.SEND_CONTRACT_OTP,
});

export const sendContractOtpSuccess = () => ({
  type: types.SEND_CONTRACT_OTP_SUCCESS,
});

export const sendContractOtpFailure = (payload) => ({
  type: types.SEND_CONTRACT_OTP_FAILURE,
  payload,
});

export const clearSendContractOtpSuccess = () => ({
  type: types.CLEAR_SEND_CONTRACT_OTP_SUCCESS,
});

export const verifyContractOtp = (payload) => ({
  type: types.VERIFY_CONTRACT_OTP,
  payload,
});

export const verifyContractOtpSuccess = () => ({
  type: types.VERIFY_CONTRACT_OTP_SUCCESS,
});

export const verifyContractOtpFailure = (payload) => ({
  type: types.VERIFY_CONTRACT_OTP_FAILURE,
  payload,
});

export const clearVerifyContractOtpSuccess = () => ({
  type: types.CLEAR_VERIFY_CONTRACT_OTP_SUCCESS,
});

export const getContract = (payload) => ({
  type: types.GET_CONTRACT,
  payload,
});

export const getContractSuccess = (payload) => ({
  type: types.GET_CONTRACT_SUCCESS,
  payload,
});

export const getContractFailure = (payload) => ({
  type: types.GET_CONTRACT_FAILURE,
  payload,
});

export const getMerchantPaymentRequiredInfo = () => ({
  type: types.GET_MERCHANT_PAYMENT_REQUIRED_INFO,
});

export const getMerchantPaymentRequiredInfoSuccess = (payload) => ({
  type: types.GET_MERCHANT_PAYMENT_REQUIRED_INFO_SUCCESS,
  payload,
});

export const getMerchantPaymentRequiredInfoFailure = (payload) => ({
  type: types.GET_MERCHANT_PAYMENT_REQUIRED_INFO_FAILURE,
  payload,
});

export const verifyMerchantCheckoutSession = (sessionId) => ({
  type: types.VERIFY_MERCHANT_CHECKOUT_SESSION,
  payload: sessionId,
});

export const verifyMerchantCheckoutSessionSuccess = (payload) => ({
  type: types.VERIFY_MERCHANT_CHECKOUT_SESSION_SUCCESS,
  payload,
});

export const verifyMerchantCheckoutSessionFailure = (payload) => ({
  type: types.VERIFY_MERCHANT_CHECKOUT_SESSION_FAILURE,
  payload,
});

/** Clears Stripe return verify flags (e.g. before mandatory payment-required-info after contract OTP). */
export const clearMerchantCheckoutVerifySession = () => ({
  type: types.CLEAR_MERCHANT_CHECKOUT_VERIFY_SESSION,
});
